import { ValueObject } from 'helpers/domain'
import {
  OpenEnrollmentStatus,
  OpenEnrollmentStatusEnum,
  OpenEnrollmentStatusSchema,
} from '../enums/open-enrollment.enums'

export class InvalidOpenEnrollmentStatusError extends Error {
  constructor(readonly invalidValue: string) {
    super(`Invalid open enrollment status: ${invalidValue}`)
    this.name = 'InvalidOpenEnrollmentStatusError'
  }
}

export class OpenEnrollmentStatusVO extends ValueObject<OpenEnrollmentStatus> {
  static readonly PENDING = OpenEnrollmentStatusEnum.PENDING
  static readonly SCHEDULED = OpenEnrollmentStatusEnum.SCHEDULED
  static readonly PAUSED = OpenEnrollmentStatusEnum.PAUSED
  static readonly CLOSED = OpenEnrollmentStatusEnum.CLOSED
  static readonly LIVE = OpenEnrollmentStatusEnum.LIVE

  constructor(value: unknown) {
    super(value as OpenEnrollmentStatus)
  }

  protected validate(): void {
    const parsed = OpenEnrollmentStatusSchema.safeParse(this._value)
    if (!parsed.success) {
      throw new InvalidOpenEnrollmentStatusError(String(this._value))
    }
  }

  static fromString(value: string): OpenEnrollmentStatusVO {
    return new OpenEnrollmentStatusVO(value)
  }

  static fromEnum(value: OpenEnrollmentStatus): OpenEnrollmentStatusVO {
    return new OpenEnrollmentStatusVO(value)
  }

  is(status: OpenEnrollmentStatus): boolean {
    return this.value === status
  }

  isPending(): boolean {
    return this.is(OpenEnrollmentStatusEnum.PENDING)
  }

  isScheduled(): boolean {
    return this.is(OpenEnrollmentStatusEnum.SCHEDULED)
  }

  isPaused(): boolean {
    return this.is(OpenEnrollmentStatusEnum.PAUSED)
  }

  isClosed(): boolean {
    return this.is(OpenEnrollmentStatusEnum.CLOSED)
  }

  isLive(): boolean {
    return this.is(OpenEnrollmentStatusEnum.LIVE)
  }
}
